import { render, staticRenderFns } from "./AssignSaleModal.vue?vue&type=template&id=93b7976a&scoped=true&"
import script from "./AssignSaleModal.vue?vue&type=script&lang=js&"
export * from "./AssignSaleModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignSaleModal.vue?vue&type=style&index=0&id=93b7976a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b7976a",
  null
  
)

export default component.exports